import 'animate.css'
import '../components/arrow.js'
import './cases.js'
import './listeners.js'
import './animated-tags.js'
import { initFooter } from './scroll'

initFooter()

